import i18n from '@/i18n';

function translatePassengerType(passengerType, count, locale = 'da') {
    let passengerTypeString =
      count > 1 ? passengerType.namePlural : passengerType.nameSingular;
  
    if (typeof passengerTypeString === 'string') {
      return passengerTypeString;
    }
  
    return passengerTypeString[locale] || passengerTypeString['da'] || Object.values(passengerTypeString)[0];
  }

export default {
 install: function(app) {
   app.config.globalProperties.$filters = {
     ...app.config.globalProperties.$filters,
     passengers: function(passengers) {
       const totalPassengers = passengers
         .map(passenger => {
           return passenger.count;
         })
         .reduce(
           (accumulator, currentValue) => accumulator + currentValue,
           0
         );

       if (totalPassengers <= 0) {
         return this.$t("filter_passenger.choose_travellers");
       }

       return passengers
         .filter(passenger => {
           return passenger.count > 0;
         })
         .map(passenger => {
           return (
             passenger.count +
             " " +
             translatePassengerType(passenger.passengerType, passenger.count, this.$i18n?.locale || 'da')

           );
         })
         .reduce(
           (accumulator, currentValue) =>
             accumulator +
             (accumulator.length > 0 ? ", " : "") +
             currentValue,
           ""
         );
     },
     passenger: function(passengerType) {
        if (typeof passengerType === 'string') {
          return passengerType
        }
      
        if (passengerType && typeof passengerType === 'object') {
          return passengerType[i18n.locale] || passengerType['da'] || Object.values(passengerType)[0]
        }
      
        return ''
      },
   };
 },
};
